import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";

import s from "~/components/_uikit/CalendarTab/CalendarTab.module.scss";
import { formatDate } from "~/utils/helpers";
import CalendarModal from "~/components/modals/calendar/CalendarModal";

interface Props {
  date: Date;
  changeDate: (newDate: Date) => void;
  allowedDates?: string[] | null;
}

const CalendarTab: React.FC<Props> = ({ date, changeDate, allowedDates }) => {
  const [isCalendarModalOpened, setIsCalendarModalOpened] =
    useState<boolean>(false);
  const [isNextButtonDisabled, setIsNextButtonDisabled] =
    useState<boolean>(false);
  const [isPreviousButtonDisabled, setIsPreviousButtonDisabled] =
    useState<boolean>(false);

  useEffect(() => {
    if (allowedDates) {
      const currentIndexOfDate = allowedDates.findIndex((item) => {
        const temp = new Date(item);
        return temp.getTime() === date.getTime();
      });
      if (currentIndexOfDate === 0) {
        setIsPreviousButtonDisabled(true);
      } else if (currentIndexOfDate === allowedDates.length - 1) {
        setIsNextButtonDisabled(true);
      }
    }
  }, [date, allowedDates]);

  const onClickNextDay = () => {
    if (!allowedDates) {
      const day = new Date(date);
      const nextDay = new Date(day);
      const result = nextDay.setDate(day.getDate() + 1);
      // const day = date.getDate()
      changeDate(new Date(result));
    } else {
      // Note: если дата есть - то нужно узнайть где именно она лежит в массиве
      const currentIndexOfDate = allowedDates.reverse().findIndex((item) => {
        const temp = new Date(item);
        return temp.getTime() === date.getTime();
      });

      if (currentIndexOfDate !== allowedDates.length - 1) {
        setIsPreviousButtonDisabled(false);
        changeDate(new Date(allowedDates[currentIndexOfDate + 1]));
      } else {
        setIsNextButtonDisabled(true);
      }
    }
  };

  const onClickPreviousDay = () => {
    if (!allowedDates) {
      const day = new Date(date);
      const nextDay = new Date(day);
      const result = nextDay.setDate(day.getDate() - 1);
      changeDate(new Date(result));
    } else {
      // Note: если дата есть - то нужно узнайть где именно она лежит в массиве
      const currentIndexOfDate = allowedDates.findIndex((item) => {
        const temp = new Date(item);
        return temp.getTime() === date.getTime();
      });

      if (currentIndexOfDate !== 0) {
        setIsNextButtonDisabled(false);
        changeDate(new Date(allowedDates[currentIndexOfDate - 1]));
      } else {
        setIsPreviousButtonDisabled(true);
      }
    }
  };

  const _formatDate = () => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const tempDateString = DateTime.utc(year, month, day)
      .toISO()
      .substring(0, 10);
    const formattedWeek = formatDate(tempDateString, "cccc").toLowerCase();
    const formattedYear = formatDate(tempDateString, "DDD").slice(0, -3);

    return `${formattedYear}, ${formattedWeek}`;
  };

  return (
    <div className={s.calendarTab}>
      <button
        className={s.calendarTabArrow}
        onClick={onClickPreviousDay}
        disabled={isPreviousButtonDisabled}
      >
        {"<"}
      </button>
      <button
        className={s.calendarTabSelector}
        onClick={() => setIsCalendarModalOpened(true)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span className="">{_formatDate()}</span>
      </button>
      <button
        className={s.calendarTabArrow}
        onClick={onClickNextDay}
        disabled={isNextButtonDisabled}
      >
        {">"}
      </button>

      <CalendarModal
        date={date}
        isOpened={isCalendarModalOpened}
        onClose={() => setIsCalendarModalOpened(false)}
        changeDate={changeDate}
        allowedDates={allowedDates}
      />
    </div>
  );
};

export default CalendarTab;
